import Vue from 'vue';
import LinkBooking from './LinkBooking.vue';

if ($('#vue-booking-link').length) {
    $(document).ready(function () {
        let anApp = new Vue({
            el: '#vue-booking-link',
            components: { LinkBooking },
        });
    });
}



// WEBPACK FOOTER //
// ./resources/scripts/portal/components/bookings/BookingLink.js